import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { AddCoverage } from "./AddCoverage";
import { colors } from "../../../ui/colors";
import NavCoverageProps from "../../interfaces/NavCoverageProps";

export const NavCoverage: React.FC<NavCoverageProps> = ({ totalAreas = 0, onSave, areaToEdit, onOpen, onCancelEdit }) => {
  const isEditing = Boolean(areaToEdit);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: 1,
        borderColor: "transparent",
        borderBottomColor: colors.gray[100],
        p: 1.5,
        mb: 1,
        // borderRadius: "8px",
      }}
    >
      <Box>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <Typography sx={{ fontWeight: 500, fontSize: 18, pr: 2 }}>{"Coverage areas"}</Typography>
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              px: 1.2,
              py: 0.3,
              bgcolor: colors.gray[100],
              color: colors.gray[500],
              borderRadius: "16px",
              fontSize: "10px",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            {totalAreas} Areas
          </Box>
        </Box>
        <Typography sx={{ fontSize: 12, py: 0.5, color: "var(--fx-surface-textsecondary, #64748B)" }}>{"Define where you operate and keep areas up to date."}</Typography>
      </Box>

      {/* <BaseModalComponent
        modalKey="Organization-CoverageAreas"
        modalLabel={isEditing ? "Edit Coverage Area" : "Add Coverage Area"}
        elementTrigger={
          <Button
            variant="contained"
            size="small"
            id="trigger-coverage-modal"
            onClick={onOpen}
            sx={{
              backgroundColor: colors.orange.base,
              color: "#fff",
              px: 2,
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              "&:hover": { backgroundColor: "#ea580c", boxShadow: "none" },
            }}
          >
            + Add coverage area
          </Button>
        }
        defaultSizes={{
          width: { xs: "95%", sm: "800px" },
          height: "700px",
        }}
      >
        <AddCoverage onSave={onSave} initialData={areaToEdit} onCancelEdit={onCancelEdit} />
      </BaseModalComponent> */}
    </Box>
  );
};

export default NavCoverage;
